'use strict';

var base = require('base/search/search');
var utils = require('pagedesigner/util/utils');
var filterBarCarousel = require('org/components/filterBarCarousel');
var previousCollapsedStates = [];

let isLoading = false;
let lastPage = 1;
let rowThreshold = 3;
let isInfiniteScroll = false;
let pageSize = 24;
let pageCountLoadMore = 0;
let totalPages = 0;
let refineurl;
let pageConfig = {};
let searchUrl = '';

/**
 * Set a cookie with selected grid value
 * @param {string} cookieName - the name of the cookie
 * @param {string} cookieValue - the class of the selected grid
 * @param {number} maxAgeSeconds - the max age of the cookie
 */
function setCookieValue(cookieName, cookieValue, maxAgeSeconds) {
    var cookie = cookieName + '=' + encodeURIComponent(cookieValue) + '; path=/';
    if (maxAgeSeconds) {
        cookie += '; max-age=' + maxAgeSeconds;
    }
    document.cookie = cookie;
}

/**
 * Close the refinements window
 *
 */
function applyRefinements() {
    $('.apply-refinements').on('click', function () {
        base.closeRefinements();
    });
}

/**
 * Builds a search key from a given URL.
 * The search key is a string containing only the query parameters that are not in the ignoreQuery array.
 * The query parameters are sorted alphabetically and then concatenated with '&' to form the search key.
 * @param {string} url - the URL to build the search key from
 * @returns {string} the search key for the given URL
 */
function getSearchKey(url) {
    var ignoreQuery = ['sz', 'start', 'page'];
    var queryParams = utils.getQueryStringParams(utils.getQueryString(url));
    if (!queryParams) {
        return '';
    }

    var keys = Object.keys(queryParams);
    var filtered = keys.filter(param => !ignoreQuery.includes(param));
    var searchKey = filtered.sort().map(param => param + '=' + queryParams[param]).join('&');

    return searchKey;
}

/**
 * Minifies HTML by removing unnecessary whitespace and comments.
 * @param {string} txt - the HTML text to minify
 * @returns {string} the minified HTML
 */
function minifyHTML(txt) {
    return txt.replace(/>\s+</g, '><').replace(/\s+/g, ' ').replace(/<!--[\s\S]*?-->/g, '');
}

/**
 * @returns {void}
 */
function updatePageVars() {
    var config = $('input[type="hidden"].pageConfig');
    if (!config || config.length === 0) {
        console.log('updatePageVars:no config');
        return;
    }
    refineurl = $('input[type="hidden"].refineUrl').last().val();
    pageConfig = JSON.parse($('input[type="hidden"].pageConfig').last().val());

    isInfiniteScroll = pageConfig.isInfiniteScroll;
    pageSize = pageConfig.pageSize;
    pageCountLoadMore = pageConfig.pageCountLoadMore;
    rowThreshold = pageConfig.rowThresholdBeforeLoad;
    var currentPage = $('.grid-footer').last().data('page-number') * 1;
    if (currentPage > lastPage) {
        lastPage = currentPage;
    }

    totalPages = $('.grid-footer').last().data('total-pages') * 1;
    var url = new URL($('.grid-footer').last().data('search-path'));
    searchUrl = url.pathname;

    console.log('updatePageVars', { isInfiniteScroll, pageSize, pageCountLoadMore, lastPage, totalPages, refineurl, pageConfig, searchUrl });
}

/**
 * Returns a debounced version of the given function.
 * @function debounce
 * @param {function} func The function to debounce.
 * @param {number} [delay=300] The amount of time to wait after the last call
 *   before the function is called.
 * @returns {function} The debounced function.
 */
function debounce(func, delay = 300) {
    console.log('debounce');
    let timeoutId;

    return function (...args) {
        const context = this;
        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}

/**
 *
 * @param {*} url - url that includes query params
 * @param {*} pageNumber - current page
 * @param {*} results - api response data
 * @returns {void}
 */
function updatePageMemory(url, pageNumber, results) {
    // only for infinite scroll
    if (!isInfiniteScroll) {
        return;
    }

    // init if not exists
    var values = JSON.parse(sessionStorage.getItem('search-results'));
    if (!values) {
        values = [];
    }

    var urlPath = window.location.pathname + '?' + utils.getQueryString(url);
    var searchKey = getSearchKey(url); // unique search query to remember
    var $productGrid = $(results).find('.product-tile-column').get().map(item => { return minifyHTML(item.outerHTML); });

    var exists = values.findIndex(item => item.searchKey === searchKey);
    window.history.replaceState({}, '', urlPath);
    if (exists > -1) {
        // update if exists
        values[exists].page = pageNumber;
        if ($productGrid.length > 0) {
            values[exists].url = urlPath;
        }
    } else {
        // add new
        values.push({
            searchKey: searchKey,
            page: pageNumber,
            url: urlPath
        });
    }

    try {
        sessionStorage.setItem('search-results', JSON.stringify(values));
        console.log('updatePageMemory', values);
    } catch (e) {
        // console.log('updatePageMemory error', { url, pageNumber, results, currentAttempt });
    }
}

/**
 * Get translation from .grid-footer data attribute
 * @param {string} key - the key to look up in the translations data
 * @returns {string} the translation for the given key
 */
function getTranslation(key) {
    const gridFooter = $('.grid-footer').last();
    const translationsData = gridFooter.data('translations');
    let translation = '';
    if (translationsData && translationsData[key]) {
        translation = translationsData[key];
    } else if (key === 'pd.label.load.more') {
        translation = 'Load More';
    } else if (key === 'plp.viewing.products') {
        translation = 'Viewing products';
    }
    return translation;
}

/**
 * Adds a viewing products paragraph with translation
 * @param {HTMLElement} wrapper - the wrapper element to append the paragraph to
 * @returns {void}
 */
function addViewingProductsParagraph(wrapper) {
    // Count current products on page (excluding promo tiles)
    const productTiles = $('.product-tile-column').get();
    let currentProducts = 0;
    productTiles.forEach(function (tile) {
        const firstChild = $(tile).children().first();
        if (firstChild.hasClass('product') && !firstChild.hasClass('promo-tile')) {
            currentProducts++;
        }
    });

    // Get total product count from .grid-footer data attribute
    const totalProducts = $('.grid-footer').last().data('total-count');

    // Get translations from .grid-footer data attribute
    const formattedText = getTranslation('plp.viewing.products').replace('{0}', currentProducts).replace('{1}', totalProducts);

    const viewingParagraph = document.createElement('p');
    viewingParagraph.className = 'viewing-products-text mb-3';
    viewingParagraph.innerHTML = formattedText;
    wrapper.appendChild(viewingParagraph);
}

/**
 * Adds a 'Load More' button to the product grid with the given URL
 * @param {string} newUrl - the URL to load more products
 * @returns {void}
 */
function addLoadMoreButton(newUrl) {
    const productSearchResults = $('.product-grid').first();
    if (productSearchResults) {
        const wrapper = document.createElement('div');
        wrapper.className = 'grid-footer position-relative text-center';

        addViewingProductsParagraph(wrapper);

        const loadMoreButton = document.createElement('button');
        loadMoreButton.className = 'btn btn-primary show-more-infinite flex-fill';
        loadMoreButton.setAttribute('data-url', newUrl);

        loadMoreButton.innerHTML = '<span class="d-md-inline text-capitalize">' + getTranslation('pd.label.load.more') + '</span>';
        wrapper.appendChild(loadMoreButton);
        $(productSearchResults).append(wrapper);
    }
}

/**
 * Removes the 'Load More' button from the product grid
 * @returns {void}
 */
function removeLoadMoreButton() {
    const showMoreButton = document.querySelector('.show-more-infinite');
    if (showMoreButton) {
        $(showMoreButton).parent().remove();
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    if (selector === '.grid-header' || selector === '.filter-bar-carousel') {
        filterBarCarousel.clearInitFlags();
    }
    $(selector).empty().html($updates.html());

    // Handling Sale / Clearance color swatch visibility on tiles
    const saleButton = $('.sale-button');
    var saleOnlyRefinementSelected = saleButton.hasClass('selected') && $('.selected', saleButton).text().toLocaleLowerCase().indexOf('sale') > -1 && $('.selected', saleButton).text().toLocaleLowerCase().indexOf('limited') > -1;
    var saleRefinementSelected = $('.on-sale-button').hasClass('selected') || ($('.selected', saleButton).hasClass('selected') && $('.selected', saleButton).text().toLocaleLowerCase().indexOf('all sale') > -1);
    var clearanceRefinementSelected = $('.on-clearance-button').hasClass('selected') || ($('.selected', saleButton).hasClass('selected') && $('.selected', saleButton).text().toLocaleLowerCase().indexOf('clearance') > -1);
    $('.product-grid').toggleClass('on-sale-only-selected', saleOnlyRefinementSelected);
    $('.product-grid').toggleClass('on-sale-selected', saleRefinementSelected);
    $('.product-grid').toggleClass('on-clearance-selected', clearanceRefinementSelected);

    // Handling Color Selection swatch visibility on tiles
    var colorRefinementSelected = $('.refinements .color-attribute .swatch-circle').hasClass('selected');
    var colorRefinementsButton = $('.filter-bar .btn-swatch-color').data('color');
    $('.product-grid').toggleClass('color-selected', colorRefinementSelected, colorRefinementsButton);

    if (selector === '.product-grid') {
        $(document.body).trigger('tileImageCarousel:init');
    }
}

/**
 * Toggle Color Swatches based on Color Refinenment
 *
 */
function toggleColorSwatches() {
    /* var excludeClasses = ['row', 'product-grid', 'row-cols-1', 'row-cols-2', 'row-cols-md-3', 'row-cols-md-4', 'row-cols-md-5', 'color-selected', 'on-sale-selected', 'on-clearance-selected', 'on-sale-only-selected'];
    var colorSwatchItems = $('.product-tile .swatches a.color-attribute span');
    var selectedSwatches = $('.product-grid').attr('class').trim().split(/\s+/);
    selectedSwatches = selectedSwatches.filter((elem) => !excludeClasses.includes(elem));

    if ($('.product-grid').hasClass('color-selected')) {
        colorSwatchItems.each(function () {
            $(this).addClass('inactive');
            for (var i = 0; i < selectedSwatches.length; i++) {
                if ($(this).hasClass(selectedSwatches[i])) {
                    $(this).toggleClass('inactive');
                    break;
                }
            }
        });
    } else {
        for (var i = 0; i < selectedSwatches.length; i++) {
            $('.product-grid').removeClass(selectedSwatches[i]);
        }
    } */
}

/**
 * Toggle refinement collapsed state
 *
 * @param {Object} $refinement - jQuery DOM element
 * @param {boolean} collapsed - collapsed flag
 */
function toggleRefinementCollapsedState($refinement, collapsed) {
    if (collapsed) {
        $refinement.find('.card-header .btn').attr('aria-expanded', 'false').addClass('collapsed');
        $refinement.find('.collapse').removeClass('show');
    } else {
        $refinement.find('.card-header .btn').attr('aria-expanded', 'true').removeClass('collapsed');
        $refinement.find('.collapse').addClass('show');
    }
}

/**
 * Scroll to results container
 *
 * @returns {void}
 */
function scrollToSearchResults() {
    const results = document.querySelector('#search-results');
    const searchResults = document.querySelector('#product-search-results');
    if (!results || !searchResults) return;

    setTimeout(() => {
        const elementPosition = searchResults.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - 58;

        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }, 150);

    results.scrollIntoView();
}

/**
 * Scroll to results container if the current URL is in the link href
 *
 * @param {string} containerSelector - the selector of the container to scroll to
 * @returns {void}
 */
function checkAndScrollToResults(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const links = container.querySelectorAll('a');
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;

    links.forEach(link => {
        if (!link.href || link.classList.contains('plp-filtering-link') || link.getAttribute('href').startsWith('#')) return;

        const linkUrl = new URL(link.href, window.location.origin);

        if (
            linkUrl.hostname === window.location.hostname &&
            linkUrl.pathname === currentPath &&
            linkUrl.search === currentSearch
        ) {
            scrollToSearchResults();
        }
    });
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement').each(function () {
        var $this = $(this);
        var refinementId = $this.attr('id');
        var $activeDiv = refinementId ? $results.find('#' + refinementId) : $();
        var isCollapsed = $('.card-header .btn', $this).hasClass('collapsed');
        if ($activeDiv.length) {
            toggleRefinementCollapsedState($activeDiv, isCollapsed);
        } else if (refinementId) {
            // Save current open/collapsed state
            previousCollapsedStates.push({
                refinementId: refinementId,
                isCollapsed: isCollapsed
            });
        }
    });

    // Set previous open/collapsed state for returning refinements
    if (previousCollapsedStates.length) {
        $('.refinement', $results).each(function () {
            var $this = $(this);
            var refinementId = $this.attr('id');
            var index = previousCollapsedStates.findIndex(r => r.refinementId === refinementId);
            if (index >= 0) {
                toggleRefinementCollapsedState($this, previousCollapsedStates[index].isCollapsed);
                // Remove previous state once applied
                previousCollapsedStates.splice(index, 1);
            }
        });
    }

    updateDom($results, '.refinements');

    // when loading the refinement selections, scroll to top of results container for a better UI
    scrollToSearchResults();
}

/**
 * Keep selected options on grid header after ajax call
 *
 * @param {Object} $results - jQuery DOM element
 */
function handleGridHeader($results) {
    var activeGridModeDesktop = $('.js-grid-toggle.active').data('gridmode');
    var activeGridModeMobile = $('.js-grid-toggle-mobile.active').data('gridmode');

    $results.find(`[data-gridmode=${activeGridModeDesktop}], [data-gridmode=${activeGridModeMobile}]`).addClass('active').siblings().removeClass('active');

    updateDom($results, '.grid-header');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.grid-header': handleGridHeader
    };

    // Update DOM elements that do not require special handling
    [
        '.search-banner:first-of-type',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar-carousel',
        '.items-count',
        '.mobile-refinement',
        '.on-sale-refinement'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    $(document.body).trigger('grid:updated');
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    try {
        var $tempDom = $('<div>').append($(response));
        var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
        sortOptions.forEach(function (option) {
            $('option.' + option.id).val(option.url);
        });
    } catch (err) {
        console.log('updateSortOptions error::>', err);
    }
}

let resizeTimeout;

/**
 * Filters Bar Mobile functions
 */
function mobileFiltersFunctions() {
    if ($('.refinements-wrapper').length) {
        // Mobile: Save refinements scroll postion
        if ($('.refinements').hasClass('all-active') && localStorage.refinementScrollPos) {
            var refinementScrollPos = JSON.parse(localStorage.getItem('refinementScrollPos'));
            $.each(refinementScrollPos, function (k, v) {
                $('.' + k).find('#' + k + '-mobile .card-body').scrollTop(v);
            });
        }

        // Toggle Clear All button (.clear-all-btn)
        var mobileRefinements = $('ul.mobile-refinement li').length;
        if (mobileRefinements === 0) {
            $('.clear-all-btn').addClass('d-none');
        } else {
            $('.clear-all-btn').removeClass('d-none');
        }
    }

    filterBarCarousel.init();
}

/**
 * Calculates page number based on start and sz parameters and
 * Adds page parameter and push new state to the browser history
 *
 * @param {string} showMoreUrl - show more url with start and sz parameters
 */
function pushState(showMoreUrl) {
    var showMoreParams = utils.getQueryStringParams(showMoreUrl);
    if (showMoreParams.start && showMoreParams.sz) {
        var page = showMoreParams.start / showMoreParams.sz;
        var newUrl = utils.removeParamFromURL(window.location.href, 'page');
        newUrl = utils.appendParamToURL(newUrl, 'page', page);

        var stateData = {
            path: newUrl,
            scrollTop: $(window).scrollTop()
        };
        window.history.pushState(stateData, document.title, newUrl);
    }
}

/**
 * Handles the response from the sorting call.
 * Replaces the grid footer with the response content, stops the spinner, and triggers the tileImageCarousel:init event.
 * Pushes a new state to the browser history with the sorting parameters.
 *
 * @param {string} response - The response content from the server.
 * @param {string} target - The target URL for the sorting.
 */
var sortResponseHandler = function (response) {
    $('.grid-footer').parent().html(response);
    toggleColorSwatches();
    $.spinner().stop();
    // $(document.body).trigger('grid:updated');
    $(document.body).trigger('tileImageCarousel:init');
};

/**
 * Handles the response from the filtering call.
 * Replaces the results with the response content, stops the spinner, and triggers the mobileFiltersFunctions event.
 * Pushes a new state to the browser history with the filter parameters.
 *
 * @param {string} response - The response content from the server.
 * @param {string} updatedURL - The URL for the updated page.
 * @param {string} updatedParams - The query string parameters for the filter.
 * @param {string} urlAnalytic - The analytics parameters to add to the URL.
 */
var filterResponseHandler = function (response) {
    parseResults(response);
    toggleColorSwatches();
    mobileFiltersFunctions();
    $.spinner().stop();
    $(document.body).trigger('tileImageCarousel:init');
    if ($('.refinement-bar').hasClass('show')) {
        filterBarCarousel.scheduleFocusDrawerCloseApplyAfterAjax();
    }
};

/**
 * Apply Sorting
 *
 * @param {string} v - url
 * @param {string} p - url parameters
 * @param {string} i - data-id
 */
function sortFunction(v, p, i) {
    var thisValue = v;
    var thisParams = p;
    var thisDataId = i;

    $.spinner().start();
    $(this).trigger('search:sort', thisValue);

    $('.sort-button, [name=sort-order] option').each(function () {
        $(this).not('buttom').removeAttr('selected');
        $(this).removeClass('selected');

        if ($(this).data('id') === thisDataId) {
            $(this).not('button').attr('selected', 'selected');
            $(this).addClass('selected');
        }
    });
    // remove sz param
    thisParams = utils.removeParamFromURL(thisValue, 'sz');
    // get query string
    const source = new URL(thisParams);
    const target = new URL(location.protocol + '//' + location.host + location.pathname);

    // Get the query parameters from the source URL
    source.searchParams.forEach((value, key) => {
        // Add each parameter to the target URL
        target.searchParams.append(key, value);
    });

    $.ajax({
        url: thisParams,
        data: {
            selectedUrl: thisParams,
            page: 0
        },
        method: 'GET',
        success: function (response) {
            sortResponseHandler(response, target, thisParams);
            lastPage = 1;
            updatePageVars();
            updatePageMemory(thisParams, lastPage, $($(document.createElement('div')).html(response)));
            window.history.pushState({
                theUrl: thisParams,
                type: 'sort',
                scrollPosition: $(window).scrollTop(),
                refinementStateHtml: $('.refinement-bar').html(),
                gridHeaderHtml: $('.grid-header').html()
            }, document.title, target.toString());
            $(document.body).trigger('tileImageCarousel:init');
        },
        error: function () {
            $.spinner().stop();
        }
    }).always(function () {
        if (!isInfiniteScroll) {
            $.spinner().stop();
        }
        isLoading = false;
    });
}

/**
 * Clear selection of PLP filter
 */
function clearPlpFilters() {
    $('.plp-filtering-link').each(function () {
        // $(this).removeClass('disabled');
        // $(this).find('.img-tile-default').each(function () {
        //     var newSrc = $(this).attr('data-src').replace('_active', '_default');
        //     $(this).attr({
        //         'data-src': newSrc,
        //         src: newSrc
        //     });
        // });
    });
}

/**
 * Toggle Read More button for seo content
 *
 */
function toggleReadMoreBtn() {
    var btnElement = document.querySelector('.show-seo-text');
    var seoTextElement = document.querySelector('.seo-text-wrapper');
    if (seoTextElement) {
        if (seoTextElement.offsetHeight < seoTextElement.scrollHeight) {
            btnElement.classList.remove('d-none');
        } else {
            btnElement.classList.add('d-none');
        }
    }
}

/**
 * Mobile drawer: collapse all refinements except the selected one,
 * expand the selected one, then scroll it into view inside .refinements-wrapper
 *
 * @param {string} elem - matches the refinement card class (e.g. "refinement-sale", "refinement-color", etc.)
 */
function openRefinementInDrawer(elem) {
    var $wrapper = $('.refinements-wrapper');
    var $allCards = $('.refinement-bar .refinements .card.refinement');
    var $target = $('.refinement-bar .refinements .card.refinement.' + elem);

    if (!$target.length) {
        return;
    }

    $allCards.each(function () {
        toggleRefinementCollapsedState($(this), true);
    });

    toggleRefinementCollapsedState($target, false);

    window.requestAnimationFrame(function () {
        if (!$wrapper.length) {
            $target.get(0).scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        var top = $target.position().top + $wrapper.scrollTop();
        var offset = 24;

        $wrapper.stop(true).animate({ scrollTop: Math.max(0, top - offset) }, 300);
    });
}

module.exports = $.extend(base, {
    init: function () {
        mobileFiltersFunctions();
        toggleColorSwatches();
        lastPage = 1;
        updatePageVars();
        checkAndScrollToResults('.search-results-top-content');
        if ($('#refinement-sort').hasClass('desktop-open') && !utils.mediaBreakpointDown('sm')) {
            $('#refinement-sort').find('.btn.title').trigger('click');
        }
    },

    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(document.body).on('click', 'button.open-refinement', function () {
            var label = $(this).attr('aria-label');
            var elem = $(this).data('elem');
            var activeRefinement = { label: label, elem: elem };
            var $cards = $('.refinement-bar .refinements .card.refinement');
            var firstOpenKey = 'plp_filters_first_open_done';
            var firstOpenDone = sessionStorage.getItem(firstOpenKey) === '1';

            localStorage.setItem('mobileActiveRefinement', JSON.stringify(activeRefinement));

            $('.refinements').addClass('all-active');

            if (elem === 'refinement-sort') {
                $('.mobile-refinement-wrap, .result-count').addClass('d-none');
            } else {
                $('.mobile-refinement-wrap, .result-count').removeClass('d-none');
            }

            $(document.body).css('overflow-y', 'hidden');
            $('.refinement-bar').addClass('show');
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.search-results').siblings().attr('aria-hidden', true);

            if (elem === 'refinement-all-filters') {
                $cards.each(function () {
                    toggleRefinementCollapsedState($(this), false);
                });
                $('.refinements-wrapper').scrollTop(0);
                filterBarCarousel.scheduleFocusRefinementBlock(elem);
            } else {
                if (!firstOpenDone) {
                    $cards.each(function () {
                        toggleRefinementCollapsedState($(this), false);
                    });
                    sessionStorage.setItem(firstOpenKey, '1');
                }

                openRefinementInDrawer(elem);
                filterBarCarousel.scheduleFocusRefinementBlock(elem);
            }
        });
        // Added Scrolltop effect for last filter result
        $(document.body).on('click', '.refinement-bar .refinements .card.refinement:last-child() .card-header button.collapsed', function () {
            setTimeout(function () {
                var refinementDiv = $('.refinement-bar .refinements').height();
                $('.refinements-wrapper').animate({ scrollTop: refinementDiv }, 500);
            }, 200);
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document.body).on('click', '.refinement-bar button.close, .refinement-bar button.apply', function () {
            $(document.body).removeAttr('style');
            var activeElem = null;
            try {
                var storedRefinement = localStorage.getItem('mobileActiveRefinement');
                if (storedRefinement) {
                    activeElem = JSON.parse(storedRefinement).elem;
                }
            } catch (e) {
                activeElem = null;
            }
            var keys = ['refinementScrollPos', 'mobileActiveRefinement'];
            keys.forEach(k => localStorage.removeItem(k));

            $('.refinement-bar').removeClass('show');
            setTimeout(function () {
                $('.mobile-refinement-wrap, .result-count').removeClass('d-none');
                $('.refinements').removeClass('all-active');
                $('.card.refinement').each(function () {
                    $(this).removeClass('d-flex');
                });
                filterBarCarousel.focusFilterBarTrigger(activeElem);
            }, 250);

            $('.refinement-bar').siblings().removeAttr('aria-hidden');
            $('.refinement-bar').closest('.row').siblings().removeAttr('aria-hidden');
            $('.refinement-bar').closest('.tab-pane.active').siblings().removeAttr('aria-hidden');
            $('.refinement-bar').closest('.search-results').siblings().removeAttr('aria-hidden');
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(document.body).on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            var thisValue = this.value;
            var thisParams = this.value.split('?')[1];
            var thisDataId = $(this).find('option:selected').data('id');
            sortFunction(thisValue, thisParams, thisDataId);
        });
    },

    sortMobile: function () {
        // Handle sort order menu selection for Mobile View
        $(document.body).on('click', '.sort-button', function (e) {
            e.preventDefault();
            var thisValue = $(this).data('value');
            var thisParams = thisValue.split('?')[1];
            var thisDataId = $(this).data('id');
            sortFunction(thisValue, thisParams, thisDataId);
        });
    },

    changePage: function () {
        isLoading = false;

        // Show more products
        const handler = function (e, state) {
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
            console.log('state', { e, state });
            var pageUrl = $(this).data('url') || $(this).val() || (state && state.theUrl);

            if (!isInfiniteScroll) {
                const element = document.getElementById('product-search-results');
                if (element && !state) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                $.spinner().start();
            }

            $.ajax({
                url: pageUrl,
                data: { selectedUrl: pageUrl },
                method: 'GET',
                success: function (response) {
                    updateSortOptions(response);
                    var divResponse = $($(document.createElement('div')).html(response));
                    updatePageMemory(pageUrl, lastPage, divResponse);

                    if (!isInfiniteScroll) {
                        $('.grid-footer').parent().html(response);
                        var showMoreParams = utils.getQueryStringParams(pageUrl);
                        if ('URLSearchParams' in window && !state) {
                            const url = new URL(window.location);
                            url.searchParams.set('page', showMoreParams.page || 1);
                            window.history.pushState({
                                theUrl: pageUrl,
                                type: 'page',
                                scrollPosition: $(window).scrollTop(),
                                refinementStateHtml: $('.refinement-bar').html(),
                                gridHeaderHtml: $('.grid-header').html()
                            }, document.title, url.toString());
                        }
                    } else {
                        var items = $(divResponse).find('.product-tile-column').get();
                        if (items && items.length > 0) {
                            $('.grid-footer').parent().append(response);
                        }
                    }
                    if (state && state.refinementStateHtml) {
                        $('.refinement-bar').html(state.refinementStateHtml);
                    }
                    if (state && state.gridHeaderHtml) {
                        $('.grid-header').html(state.gridHeaderHtml);
                    }
                    $(document.body).trigger('tileImageCarousel:init');
                },
                error: function () {
                }
            })
                .always(function () {
                    if (!isInfiniteScroll) {
                        $.spinner().stop();
                    }
                    isLoading = false;
                    removeLoadMoreButton();
                });
        };
        const loadMoreInfinite = function () {
            const showMoreButton = document.querySelector('.show-more-infinite');
            const newUrl = showMoreButton.getAttribute('data-url');
            handler(null, {
                theUrl: newUrl
            });
        };
        window.addEventListener('popstate', function (e) {
            console.log('popstate', e);
            // if the state is the page you expect, pull the name and load it.
            if (e.state && e.state.theUrl) {
                switch (e.state.type) {
                    case 'sort':
                        $.spinner().start();
                        $.ajax({
                            url: e.state.theUrl,
                            data: {
                                page: 0,
                                selectedUrl: e.state.theUrl
                            },
                            method: 'GET',
                            success: function (response) {
                                sortResponseHandler(response);

                                updatePageVars();
                                if (e.state.scrollPosition) {
                                    window.scrollTo(0, e.state.scrollPosition);
                                }
                                if (e.state.refinementStateHtml) {
                                    $('.refinement-bar').html(e.state.refinementStateHtml);
                                }
                                if (e.state.gridHeaderHtml) {
                                    $('.grid-header').html(e.state.gridHeaderHtml);
                                }
                            },
                            error: function () {
                            }
                        })
                            .always(function () {
                                if (!isInfiniteScroll) {
                                    $.spinner().stop();
                                }
                                isLoading = false;
                            });
                        break;
                    case 'page':
                        handler(e, e.state);
                        break;
                    case 'filter':
                        $.spinner().start();
                        $.ajax({
                            url: e.state.theUrl,
                            data: {
                                page: 0,
                                selectedUrl: e.state.theUrl
                            },
                            method: 'GET',
                            success: function (response) {
                                filterResponseHandler(response);
                                if (e.state.scrollPosition) {
                                    window.scrollTo(0, e.state.scrollPosition);
                                }
                                updatePageVars();
                            },
                            error: function () {
                            }
                        })
                            .always(function () {
                                if (!isInfiniteScroll) {
                                    $.spinner().stop();
                                }
                                isLoading = false;
                            });
                        break;
                    default:
                }
            } else {
                console.log('no state popstate');
                window.location.href = window.location.href;
            }
        });
        const debouncedHandler = debounce(handler, 100);
        $(window).on('scroll', function () {
            if (!isInfiniteScroll) {
                return;
            }

            if (lastPage >= totalPages) {
                console.log('last page reached');
                return;
            }

            const $element = $('.product-grid').find('.product-tile-column').last();
            const $productGrid = $('.product-grid');
            const productGridBottom = $productGrid.offset().top + $productGrid.height();

            // Get current scroll position
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();

            // Get element position and dimensions
            const elementOffset = $element.offset();
            const elementHeight = $element.outerHeight();

            // Calculate distance from element bottom to viewport bottom
            const elementTop = elementOffset.top;
            const viewportBottom = scrollTop + windowHeight;
            const distanceFromBottom = elementTop - viewportBottom;

            const isAboveView = scrollTop > productGridBottom;
            console.log('isAboveView', isAboveView);
            if (isAboveView) {
                console.log('scroll event above view', {
                    distanceFromBottom,
                    withinRange: (elementHeight * rowThreshold) > distanceFromBottom,
                    viewportBottom,
                    elementTop,
                    productGrid: productGridBottom,
                    isAboveView
                });
                return;
            }

            console.log('scroll event', {
                distanceFromBottom,
                withinRange: (elementHeight * rowThreshold) > distanceFromBottom,
                viewportBottom,
                elementTop,
                productGrid: productGridBottom,
                isAboveView
            });

            if ((elementHeight * rowThreshold) > distanceFromBottom && !isLoading) {
                isLoading = true; // prevent multiple calls until Ajax is resolved

                updatePageVars();
                var start = (pageSize * lastPage);
                lastPage++;

                var searchKey = getSearchKey(refineurl);
                var path = searchUrl + '?' + searchKey;

                var newUrl = utils.appendParamToURL(window.location.origin + path, 'start', start);
                newUrl = utils.appendParamToURL(newUrl, 'page', lastPage);
                newUrl = utils.appendParamToURL(newUrl, 'sz', pageSize);

                // if modulo of load more page count is 0 and not the last page
                if (lastPage % pageCountLoadMore === 0 && lastPage < totalPages) {
                    console.log('adding load more button', { modulo: lastPage % pageCountLoadMore, pageCountLoadMore, lastPage, totalPages, newUrl });
                    addLoadMoreButton(newUrl);
                    return;
                }

                console.log('calling handler', { current: window.location.href, start, lastPage, newUrl, totalPages });
                debouncedHandler(null, { theUrl: newUrl });
                // handler(null, {
                //     theUrl: newUrl
                // });
            }
        });
        $('#search-results').on('change', 'select', handler);
        $('#search-results').on('click', '.plp-pagination .page-link-custom', handler);
        $('#search-results').on('click', '.show-more-infinite', loadMoreInfinite);
        $('#search-results').on('shown.bs.dropdown', '.special-select', function () {
            var $dropdownMenu = $(this).find('.dropdown-menu');
            var $selectedItem = $dropdownMenu.find('.dropdown-item.selected');

            if ($selectedItem.length > 0) {
                $selectedItem.get(0).scrollIntoView({
                    block: 'center'
                });
            }
        });
    },
    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document.body).on(
            'click',
            '.plp-filtering-link, .on-sale-button, .refinements li button:not(.sort-button), button.clear-refinements, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                // Toggle the filter classes on product grid
                var $grid = $('.product-grid');
                var colorSelectionAlreadyApplied = $('.product-grid.color-selected');
                var $this = $(this);
                var swatchColor = $this.data('color');

                if (swatchColor && swatchColor.length > 0) {
                    if (colorSelectionAlreadyApplied.length > 0) {
                        if (colorSelectionAlreadyApplied.hasClass(swatchColor)) {
                            $grid.removeClass(swatchColor);
                        } else {
                            $grid.addClass(swatchColor);
                        }
                    } else {
                        $grid.addClass(swatchColor);
                    }
                }

                // Mobile: Save refinements scroll postion
                if ($('.refinements').hasClass('all-active')) {
                    var refinementScrollPos = {};
                    $('.card.refinement').each(function () {
                        var id = $(this).attr('id');
                        var pos = $(this).find('#' + id + '-mobile .card-body').scrollTop();
                        refinementScrollPos[id] = pos;
                    });
                    localStorage.setItem('refinementScrollPos', JSON.stringify(refinementScrollPos));
                }

                $.spinner().start();

                // Modifying the refinements link before call to add the active sorting rule parameter as SRFA OOTB doesn't keep Sort on refinement change
                var sortParam = new URLSearchParams($('.result-sort').find('[name=sort-order]').val()).get('srule');
                var href = $this.data('href') || $this.attr('data-href');
                if (!href) return;

                var urlSplit = href.split('?');
                var baseUrl = urlSplit[0];
                var updatedParams = new URLSearchParams(urlSplit[1] || '');
                var urlAnalytic = '';
                clearPlpFilters();
                if ($this.hasClass('plp-filtering-link')) {
                    $(this).trigger('plpFiltering');
                    urlSplit[0] = $this.data('url');

                    if (urlSplit[1].indexOf('icid=') >= 0 || urlSplit[1].indexOf('ecid=') >= 0) {
                        // Filtering by TCatE considering parameter for analytics
                        var regex = new RegExp(/(i|e)cid/);
                        var campaignParam = urlSplit[1].match(regex)[0];
                        urlAnalytic = '&' + campaignParam + '=' + updatedParams.get(campaignParam);
                        urlSplit[1] = urlSplit[1].split('&' + campaignParam)[0];
                        updatedParams.delete(campaignParam);
                    }
                }

                var currURLParams = new URLSearchParams(document.location.href.split('?')[1]);
                if (currURLParams.get('srule') || !currURLParams.get('q')) {
                    updatedParams.set('srule', sortParam);
                }
                updatedParams = updatedParams.toString();
                var updatedURL = baseUrl + (updatedParams.toString() ? ('?' + updatedParams.toString()) : '');
                $this.trigger('search:filter', e);

                $.ajax({
                    url: updatedURL,
                    data: {
                        page: 0,
                        selectedUrl: updatedURL
                    },
                    method: 'GET',
                    success: function (response) {
                        filterResponseHandler(response);
                        lastPage = 1;
                        updatePageVars();
                        updatePageMemory(updatedURL, lastPage, response);
                        window.history.pushState({
                            theUrl: updatedURL,
                            type: 'filter',
                            scrollPosition: $(window).scrollTop()
                        }, document.title, document.location.href.split('?')[0] + '?' + updatedParams + urlAnalytic);
                    },
                    error: function () {
                    }
                })
                    .always(function () {
                        $.spinner().stop();
                        isLoading = false;
                    });
            });
    },

    plpFiltering: function () {
        $('body').on('plpFiltering', function (e) {
            var $this = $(e.target);
            $this.closest('.experience-tileCarousel_E').find('a').removeClass('disabled');
            $this.closest('.experience-tileCarousel_E').find('picture.picture-tile').each(function () {
                var sources = $(this).find('source');
                sources.each(function () {
                    if ($(this).attr('srcset')) {
                        $(this).attr('srcset', $(this).attr('srcset').replace('_active', '_default'));
                    }
                    if ($(this).attr('data-src')) {
                        $(this).attr('data-src', $(this).attr('data-src').replace('_active', '_default'));
                    }
                });
                $this.find('.img-tile-default').attr('src').replace('_active', '_default');
            });

            $this.addClass('disabled');
            $this.find('picture.picture-tile').each(function () {
                var sources = $(this).find('source');
                sources.each(function () {
                    if ($(this).attr('srcset')) {
                        $(this).attr('srcset', $(this).attr('srcset').replace('_default', '_active'));
                    }
                    if ($(this).attr('data-src')) {
                        $(this).attr('data-src', $(this).attr('data-src').replace('_default', '_active'));
                    }
                });
                $this.find('.img-tile-default').attr('src').replace('_default', '_active');
            });
        });
    },

    colorAttribute: function () {
        // Swatches mouse over events on non-mobile devices to update tile images and PDP/QV URL based on each swatch variation
        if (!utils.isMobile()) {
            $(document.body).on('mouseenter', '.color-swatches .color-attribute[data-colorimage]', function () {
                var $this = $(this);
                var $parentTile = $this.parents('.product-tile');
                var variationURL = $this.attr('href');
                var $qvLink = $parentTile.find('a.quickview');

                var swatchImages = [
                    {
                        src: $this.attr('data-colorimage'),
                        srcset: $this.attr('data-colorimagesrcset') || '',
                        sizes: $this.attr('data-colorimagesizes') || ''
                    },
                    {
                        src: $this.attr('data-colorimagehover'),
                        srcset: $this.attr('data-colorimagehoversrcset') || '',
                        sizes: $this.attr('data-colorimagesizes') || ''
                    }
                ];

                // Handle images loading/swap
                swatchImages.forEach(function (entry, index) {
                    if (entry && entry.src) {
                        var applyTileImage = function () {
                            var $tileImg = $parentTile.find('.tile-image').eq(index);
                            if (!$tileImg.length) {
                                return;
                            }
                            // When srcset is present, browsers ignore src for display — always replace/clear it.
                            $tileImg.attr('src', entry.src);
                            if ($tileImg.attr('data-src')) {
                                $tileImg.attr('data-src', entry.src);
                            }
                            if (entry.srcset) {
                                $tileImg.attr('srcset', entry.srcset);
                                $tileImg.attr('data-srcset', entry.srcset);
                            } else {
                                $tileImg.removeAttr('srcset');
                                $tileImg.removeAttr('data-srcset');
                            }
                            if (entry.sizes) {
                                $tileImg.attr('sizes', entry.sizes);
                                $tileImg.attr('data-sizes', entry.sizes);
                            }
                        };

                        var newImage = new Image();
                        $(newImage).on('load', applyTileImage);
                        newImage.src = entry.src;
                        // Cached images may have already completed before the load handler attached
                        if (newImage.complete && newImage.naturalWidth) {
                            applyTileImage();
                        }
                    }
                });

                // Handle tile/qv links update
                if (variationURL) {
                    var productId = $parentTile.parent('.product').data('pid');
                    var colorId = $this.data('color-id');
                    var qvParams = `&pid=${productId}&dwvar_${productId}_color=${colorId}&ajax=true`;

                    $qvLink.attr('href', function (index, value) {
                        return value.split('&pid')[0] + qvParams;
                    });
                    $parentTile.find('a.image-pdp-link, .pdp-link a.link').attr('href', variationURL);
                }
            });
        }
    },

    showMoreLess: function () {
        applyRefinements();
    },

    productGridToggler: function () {
        $(document.body).on('click', '.js-grid-toggle-mobile, .js-grid-toggle', function (e) {
            e.preventDefault();
            var $this = $(this);
            var isMobileToggler = $this.is('.js-grid-toggle-mobile');
            var gridMode = $this.data('gridmode');
            var $grid = $('.product-grid');

            var mobileMode = isMobileToggler ? gridMode : ($('.js-grid-toggle-mobile.active').data('gridmode') || 'row-cols-2');
            var desktopMode = isMobileToggler ? ($('.js-grid-toggle.active').data('gridmode') || 'row-cols-md-5') : gridMode;
            setCookieValue('grid-toggle-active-state', JSON.stringify({ mobile: mobileMode, desktop: desktopMode }), 60 * 60 * 24 * 365);

            if (isMobileToggler) {
                $grid.removeClass('row-cols-1 row-cols-2').addClass(gridMode);
                $this.addClass('active').siblings('.js-grid-toggle-mobile').removeClass('active');
            } else {
                $grid.removeClass('row-cols-md-4 row-cols-md-5 row-cols-md-6').addClass(gridMode);
                $this.addClass('active').siblings('.js-grid-toggle').removeClass('active');
            }
        });
    },

    seoTextBtnToggle: function () {
        toggleReadMoreBtn();

        $(window).on('resize', function () {
            toggleReadMoreBtn();
        });
    },

    seoTextExpand: function () {
        $(document.body).on('click', '.show-seo-text', function () {
            $('.seo-text-wrapper').addClass('expanded');
        });
    },

    updateBrowserUrl: function () {
        // Update the PLP browser url with the ajax call parameters to support back button / refresh / shared link
        $(document.body).on('updateBrowserUrl', function (e, calledParams) {
            var updatedURL = document.location.href.split('?')[0] + '?' + calledParams;
            history.pushState(null, null, updatedURL);
        });
    },

    /**
     * Pushes new state to browser history on search:showMore event
     * which is fired when user clicks on show more button
     */
    initPushState: function () {
        $('body').on('search:showMore', function (e) {
            if (e.target && e.target.dataset && e.target.dataset.url) {
                pushState(e.target.dataset.url);
            }
        });
    },

    /**
     * On resize, render refinement-bar carosuel
     * Sticks refinement-bar to header if so.
     */
    resize: function () {
        utils.smartResize(function () {
            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(function () {
                filterBarCarousel.init();
            }, 100);
        });
    },

    /**
     * On scroll, stick refinement bar to header
     */
    scroll: function () {
        let stickyMenuOffsetTop;
        let stickyOffsetCaptured = false;
        let headerStuckObserver = null;
        let pinWithoutTransition = false;
        var waitForHeaderStuck;

        /**
         * Reset sticky offset
         */
        function resetStickyOffset() {
            stickyOffsetCaptured = false;
        }

        /**
         * Stop waiting for the header stuck class
         */
        function disconnectHeaderWait() {
            if (headerStuckObserver) {
                headerStuckObserver.disconnect();
                headerStuckObserver = null;
            }
        }

        /**
         * Header stick is debounced. True while is-stuck is still pending.
         * @param {HTMLElement} siteHeader - site header element
         * @returns {boolean} whether the header is about to stick
         */
        function headerStickPending(siteHeader) {
            var trigger;

            if (siteHeader.classList.contains('is-stuck') || !('IntersectionObserver' in window)) {
                return false;
            }

            if (document.querySelector('.menu-toggleable-left.in')) {
                return false;
            }

            trigger = document.querySelector('.sticky-scroll-trigger');
            if (!trigger) {
                return false;
            }

            return trigger.getBoundingClientRect().bottom <= 0;
        }

        /**
         * Pin the filter bar under the stuck header
         * @param {HTMLElement} filtersBlock - mobile filters wrapper
         * @param {HTMLElement} searchResults - search results container
         * @param {HTMLElement} siteHeader - site header
         * @param {number} headerStickyHeight - stuck header height
         * @param {number} filtersHeight - filter bar height
         * @param {boolean} immediate - skip the top transition for this placement
         */
        function pinFilters(filtersBlock, searchResults, siteHeader, headerStickyHeight, filtersHeight, immediate) {
            if (immediate) {
                filtersBlock.style.transition = 'none';
            }

            filtersBlock.classList.add('is-sticky');
            filtersBlock.style.top = headerStickyHeight + 'px';
            searchResults.style.paddingTop = filtersHeight + 'px';
            siteHeader.classList.add('shadow-none');

            if (immediate) {
                // Apply the corrected top before the stylesheet transition can run from 0
                filtersBlock.getBoundingClientRect();
                filtersBlock.style.transition = '';
            }
        }

        /**
         * Update stick mobile refinement bar to header
         */
        function updateStickyFilters() {
            var siteHeader = document.getElementById('header');
            var filtersBlock = document.getElementById('mobile-filters-wrap');
            var headerIsStuck;
            var headerStickyHeight;
            var filtersHeight;
            var searchResults;
            var immediatePin;
            var shouldStick;

            if (!siteHeader || !filtersBlock) {
                return;
            }

            headerIsStuck = siteHeader.classList.contains('is-stuck');
            headerStickyHeight = headerIsStuck ? siteHeader.offsetHeight : 0;
            filtersHeight = filtersBlock.offsetHeight;
            searchResults = document.getElementById('product-search-results');
            immediatePin = pinWithoutTransition;
            pinWithoutTransition = false;

            if (!stickyOffsetCaptured) {
                stickyMenuOffsetTop = document.documentElement.scrollTop + filtersBlock.getBoundingClientRect().top;
                stickyOffsetCaptured = true;
            }

            shouldStick = document.documentElement.scrollTop >= stickyMenuOffsetTop - headerStickyHeight;

            if (shouldStick && headerStickPending(siteHeader)) {
                pinWithoutTransition = immediatePin;
                waitForHeaderStuck(siteHeader);
                return;
            }

            disconnectHeaderWait();

            if (shouldStick) {
                pinFilters(filtersBlock, searchResults, siteHeader, headerStickyHeight, filtersHeight, immediatePin);
            } else {
                filtersBlock.classList.remove('is-sticky');
                filtersBlock.style.top = '';
                filtersBlock.style.transition = '';
                searchResults.style.paddingTop = '';
                siteHeader.classList.remove('shadow-none');
                stickyOffsetCaptured = false;
            }
        }

        /**
         * Re-run sticky filters once the header receives is-stuck
         * @param {HTMLElement} siteHeader - site header element
         */
        waitForHeaderStuck = function (siteHeader) {
            if (headerStuckObserver) {
                return;
            }

            headerStuckObserver = new MutationObserver(function () {
                var filtersBlock;

                if (!siteHeader.classList.contains('is-stuck')) {
                    return;
                }

                disconnectHeaderWait();
                filtersBlock = document.getElementById('mobile-filters-wrap');
                if (!filtersBlock || !filtersBlock.classList.contains('is-sticky')) {
                    stickyOffsetCaptured = false;
                }
                pinWithoutTransition = true;
                updateStickyFilters();
            });
            headerStuckObserver.observe(siteHeader, { attributes: true, attributeFilter: ['class'] });
        };

        /**
         * Schedule sticky update
         */
        function scheduleStickyUpdate() {
            resetStickyOffset();
            window.requestAnimationFrame(updateStickyFilters);
        }

        $(document.body).on('grid:updated.plpStickyFilters plpFilters:updated.plpStickyFilters', scheduleStickyUpdate);
        $(window).on('scroll.plpStickyFilters', updateStickyFilters);
        // Desktop can restore scroll on back/refresh before this listener exists, so no scroll event follows
        updateStickyFilters();
    }
});
